// Get Thumbnail
const getThumbnail = (value) => {
  let imgParts = value.split('.');
  let ext = imgParts.pop();
  let imgThumb = imgParts.join('.') + '-thumb.' + ext;
  // Works for both images.atolyestore.com and legacy dev.images.atolyestore.com
  imgThumb = imgThumb.replace(
    /^(https:\/\/(?:dev\.)?images\.atolyestore\.com)\/products\//,
    '$1/product_thumbs/',
  );

  return imgThumb;
};

export default getThumbnail;
